import { assert, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import { v3 } from "oc-threejs/short3";

export default {
  name: "TestVorgartenElemente",
};

export const testRhombusVorgartenElement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[1];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Bambus");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x90_Easy");
  element.change({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  agt.update3d();
  assert.same("2939 SYSTEM RHOMBUS Bambus Vorgartenzaun  180 x 90 cm", element.meta.Key);
};

export const testRhombusElementWithStandardSize: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[1];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Bambus");
  element.change({
    füllungAuswahlwert,
  });
  agt.update3d();
  assert.isTrue(element.isBauseitskürzbaresElement);
  assert.same("2937 SYSTEM RHOMBUS Bambus 180 x 180 cm", element.meta.Key);
};

export const testRhombusElementWith180x96cmSize: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[1];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Bambus");
  const size = v3(1.8, 0.96, 0);
  element.change({
    füllungAuswahlwert,
    size: size as any,
  });
  agt.update3d();
  assert.isTrue(element.isBauseitskürzbaresElement);
  assert.same("2937 SYSTEM RHOMBUS Bambus 180 x 180 cm", element.meta.Key);
};

export const testRhombusElementWith180x84cmSize: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[1];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Bambus");
  const size = v3(1.8, 0.84, 0);
  element.change({
    füllungAuswahlwert,
    size: size as any,
  });
  agt.update3d();
  assert.isTrue(element.isBauseitskürzbaresElement);
  assert.same("2939 SYSTEM RHOMBUS Bambus Vorgartenzaun  180 x 90 cm", element.meta.Key);
};

// in der Praxis wird die Size stehts unabhängig vom der Füllung gesetzt
export const testRhombusElementWith180x84cmSizeTwoSteps: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[1];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Bambus");
  element.change({
    füllungAuswahlwert,
  });
  agt.update3d();
  assert.same(element.meta.Key, "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm");
  element.höhe = 0.84;
  agt.update3d();
  assert.isTrue(element.isBauseitskürzbaresElement);
  assert.same(
    "2939 SYSTEM RHOMBUS Bambus Vorgartenzaun  180 x 90 cm",
    element.meta.Key,

    "es wird ein zu großes Maßelement gewählt"
  );
};
